export interface PageSize {
    width: number;
    height: number;
}

const LOGO_WIDTH = 64;
const LOGO_MARGIN = 20;
const LOGO_ALPHA = 0.5;

const FONT_SETTINGS = '20px Open sans';
const FONT_ALIGN = 'center';
const FONT_COLOR = '#838383';
const ROTATION_DIVISOR = 4;
const FONT_ROTATION_ANGLE = -Math.PI / ROTATION_DIVISOR;
const FONT_ALPHA = 0.33;

export const imageWatermarkPlugin = (
    img: HTMLImageElement,
    ctx: CanvasRenderingContext2D,
    pageSize: PageSize,
): void => {
    const imgRatio = img.height / img.width;
    const adjustedHeight = LOGO_WIDTH * imgRatio;

    ctx.save();

    ctx.globalAlpha = LOGO_ALPHA;
    ctx.drawImage(
        img,
        pageSize.width - LOGO_WIDTH - LOGO_MARGIN,
        pageSize.height - adjustedHeight - LOGO_MARGIN,
        LOGO_WIDTH,
        adjustedHeight,
    );

    ctx.restore();
};

const EMAIL_WATERMARK_Y_TRANSLATION_COEFF = 2;
const EMAIL_WATERMARK_TOP = 0.15;
const EMAIL_WATERMARK_MIDDLE = 0.5;
const EMAIL_WATERMARK_BOTTOM = 0.85;
const EMAIL_WATERMARK_PERCENTAGES: number[] = [
    EMAIL_WATERMARK_TOP,
    EMAIL_WATERMARK_MIDDLE,
    EMAIL_WATERMARK_BOTTOM,
];

export const emailWatermarkPlugin = (
    userEmail: string,
    ctx: CanvasRenderingContext2D,
    pageSize: PageSize,
): void => {
    ctx.save();

    ctx.globalAlpha = FONT_ALPHA;
    ctx.font = FONT_SETTINGS;
    ctx.textAlign = FONT_ALIGN;
    ctx.fillStyle = FONT_COLOR;

    EMAIL_WATERMARK_PERCENTAGES.forEach((percentage) => {
        ctx.save();
        ctx.translate(pageSize.width * percentage, pageSize.height / EMAIL_WATERMARK_Y_TRANSLATION_COEFF);
        ctx.rotate(FONT_ROTATION_ANGLE);
        ctx.fillText(userEmail, 0, 0);
        ctx.restore();
    });

    ctx.restore();
};
